
import { initializeApp} from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA93WXMEjqhfHlvv-PQ49G4wPM5hlg6xhY",
  authDomain: "studiomercy.firebaseapp.com",
  projectId: "studiomercy",
  storageBucket: "studiomercy.firebasestorage.app",
  messagingSenderId: "667755192298",
  appId: "1:667755192298:web:cc811913d09e91e472dc93"
};



const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);